/**
 * Global Declarations.
 */
/// <reference types="vite-plugin-svgr/client" />

/**
 * Polyfills
 */
import "navigator.locks";

/**
 * Imports (Ordered).
 */
import { mountApp } from "@/app/mount";
import { globalStateModule } from "@/modules/global-state";
import { globalStateService as commonEditorGlobalStateModule } from "@mem-labs/common-editor";

/**
 * App Setup.
 */
import { handleEphemeralRoutes } from "@/app/router/handle-ephemeral-routes";
import { registerEphemeralRouteHandlers } from "@/app/router/ephemeral-routes";
import { captureAndStripUtmParams } from "@/app/router/utm-params";

const startApp = async () => {
  // Capture UTM params first, before anything modifies the URL
  // This ensures analytics can track them even after we strip them
  captureAndStripUtmParams();

  registerEphemeralRouteHandlers();
  handleEphemeralRoutes();

  await globalStateModule.initialize();
  await commonEditorGlobalStateModule.initialize();

  mountApp();
};

startApp();
